import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Home, Calendar, ShoppingBag, MessageSquare, Users, Star } from 'lucide-react'

const items = [
  { name: 'Home', path: '/', icon: Home },
  { name: 'Calendar', path: '/calendar', icon: Calendar },
  { name: 'Market', path: '/marketplace', icon: ShoppingBag },
  { name: 'Forums', path: '/forums', icon: MessageSquare },
  { name: 'Artists', path: '/artists', icon: Users },
]

const MobileNav: React.FC = () => {
  const location = useLocation()

  return (
    <nav className="fixed bottom-3 left-1/2 -translate-x-1/2 z-50 w-[95%] max-w-xl xl:hidden">
      <div className="glass-card border border-white/10 rounded-2xl px-2 py-2 backdrop-blur-lg">
        <ul className="grid grid-cols-5 items-center">
          {items.map((item) => {
            const Icon = item.icon
            const isActive = location.pathname === item.path
            return (
              <li key={item.name} className="text-center">
                <Link
                  to={item.path}
                  className={`flex flex-col items-center justify-center gap-1 py-2 rounded-xl transition-colors ${
                    isActive ? 'text-le-accent bg-white/5' : 'text-white/70 hover:text-white'
                  }`}
                >
                  <Icon size={20} />
                  <span className="text-[11px] leading-none">{item.name}</span>
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
    </nav>
  )
}

export default MobileNav


